// Drawn like a git graph. Each entry is a "commit".
// lane 0 is the main line; things that ran in parallel live on lanes 1 and 2 as branches.
export const entries = [
  {
    id: "eustella",
    date: "2026-03-01",
    lane: 0,
    period: "March 2026 – Present",
    title: "Co-Founder & CEO",
    place: "eustella",
    url: "https://eustella.com",
    current: true,
  },
  {
    id: "studies-end",
    date: "2026-01-31",
    lane: 0,
    period: "January 2026",
    title: "End of studies",
    place: "BA Philosophy & Law",
  },
  {
    id: "newsrooms-ceo",
    date: "2025-10-01",
    lane: 0,
    period: "October 2025",
    title: "Co-Founder & CEO",
    place: "newsrooms",
  },
  {
    id: "newsrooms-cofounder",
    date: "2025-08-01",
    lane: 0,
    period: "August 2025",
    title: "Co-Founder & CTO",
    place: "newsrooms",
  },
  {
    id: "law",
    date: "2024-10-01",
    lane: 2,
    period: "October 2024",
    title: "Law",
    place: "Juridicum Wien",
  },
  {
    id: "newsrooms-cto",
    date: "2024-09-01",
    lane: 0,
    period: "September 2024",
    title: "CTO",
    place: "newsrooms",
  },
  {
    id: "volunteering-end",
    date: "2024-08-31",
    lane: 0,
    period: "August 2024",
    title: "End of volunteering",
    place: "Educator & Speaker",
  },
  {
    id: "philosophy",
    date: "2024-03-01",
    lane: 1,
    period: "March 2024",
    title: "BA Philosophy",
    place: "University of Vienna",
  },
  {
    id: "volunteering",
    date: "2023-08-01",
    lane: 2,
    period: "August 2023",
    title: "Educator & Speaker",
    place: "Volunteer work",
  },
  {
    id: "trending-topics",
    date: "2023-05-01",
    lane: 0,
    period: "May 2023 – September 2024",
    title: "Lead Developer, Project newsrooms",
    place: "Trending Topics",
  },
  {
    id: "htl",
    date: "2018-09-01",
    lane: 0,
    period: "2018 – 2023",
    title: "High Potential",
    place: "HTL Spengergasse",
  },
];

// A branch forks off the main line just below `from`,
// and either merges back into the commit `mergeInto` or keeps running to the present.
// The main line flows up into the stem of the rose.
export const branches = [
  { lane: 1, from: "philosophy", mergeInto: "studies-end" },
  { lane: 2, from: "law", mergeInto: "studies-end" },
  { lane: 2, from: "volunteering", mergeInto: "volunteering-end" },
];

// Talks, podcasts, TV, press and jury work, shown as notes in the timeline's margin
export const appearances = [
  {
    id: "falter-2026",
    date: "2026-07-21",
    period: "21 Jul 2026",
    format: "Profile",
    title: "FALTER",
    place: "Wie eine kleine Wiener App im großen KI-Wettrennen mitmischt",
    url: "https://www.falter.at/zeitung/20260721/wie-eine-kleine-wiener-app-im-grossen-ki-wettrennen-mitmischt",
  },
  {
    id: "zeit-2026",
    date: "2026-07-03",
    period: "3 Jul 2026",
    format: "Press",
    title: "DIE ZEIT",
    place: "KI-Modelle in Europa: Es muss nicht immer das Beste sein",
    url: "https://www.zeit.de/digital/2026-07/ki-modelle-europa-usa-mythos-anthropic-fable",
  },
  {
    id: "ki-kompass-2026",
    date: "2026-06-25",
    period: "25 Jun 2026",
    format: "Interview",
    title: "KI Kompass",
    place: "„Ein Stück digitale Unabhängigkeit, made in Austria“",
    url: "https://ki-kompass.at/eustella-matteo-rosoli-interview/",
  },
  {
    id: "standard-2026",
    date: "2026-06-25",
    period: "25 Jun 2026",
    format: "Press",
    title: "DER STANDARD",
    place:
      "Guter Preis, Daten in der EU: Der österreichische KI-Begleiter Eustella stellt sich vor",
    url: "https://www.derstandard.de/story/3000000328657/guter-preis-daten-in-der-eu-der-oesterreichische-ki-begleiter-eustella-stellt-sich-vor",
  },
  {
    id: "brutkasten-2026",
    date: "2026-06-25",
    period: "25 Jun 2026",
    format: "Press",
    title: "brutkasten",
    place:
      "Eustella: Wiener Claude- und ChatGPT-Herausforderer geht in Vollbetrieb",
    url: "https://brutkasten.com/artikel/eustella-wiener-claude-und-chatgpt-herausforderer-geht-in-vollbetrieb/15",
  },
  {
    id: "trend-2026",
    date: "2026-06-24",
    period: "24 Jun 2026",
    format: "Interview",
    title: "trend.",
    place: "Ein Wiener Start-up als Alternative zu ChatGPT & Co.",
    url: "https://www.trend.at/tech/ki-made-in-europe-fragen-sie-doch-mal-eustella",
  },
  {
    id: "1e9-2026",
    date: "2026-04-17",
    period: "17 Apr 2026",
    format: "Interview",
    title: "1E9",
    place: "Eustella: Ein Start-up arbeitet an einem KI-Assistenten für Europa",
    url: "https://www.1e9.community/magazin/eustella-ein-start-up-arbeitet-an-einem-ki-assistenten-f%C3%BCr-europa",
  },
  {
    id: "medianet-2026",
    date: "2026-01-01",
    period: "2026",
    format: "Interview",
    title: "medianet",
    place: "ChatGPT klingt wie KI. newsrooms klingt wie Sie",
    url: "https://medianet.at/news/marketing-and-media/chatgpt-klingt-wie-ki-newsrooms-klingt-wie-sie-72517.html",
  },
  {
    id: "rtss-2025",
    date: "2025-12-11",
    period: "11 Dec 2025",
    format: "Jury",
    title: "Road to START Summit Vienna 2025",
    place:
      "Startup pitch competition, with Luisa Schiffke, Fabian Rieth and Mealea Schäfer",
    url: "https://www.start-vienna.com/rtss",
  },
  {
    id: "start-hackathon-2025",
    date: "2025-10-24",
    period: "24 Oct 2025",
    format: "Jury",
    title: "START Vienna Hackathon",
    place: "Main jury, with Lukas Plechinger and Rafael Danner",
    url: "https://newsrooms.ai/blog/de/start-hackathon-wien-jury/",
  },
  {
    id: "cio-kongress-2022",
    date: "2022-10-09",
    period: "9–11 Oct 2022",
    format: "Presentation",
    title: "CIO Kongress, Bad Loipersdorf",
    place:
      "Automated article creation and sentiment analysis, with Alexander Maitz",
    url: "https://www.spengergasse.at/?p=6041",
  },
  {
    id: "theatermuseum-2024",
    date: "2024-03-14",
    period: "14 Mar 2024",
    format: "Panel",
    title: "Theatermuseum Wien",
    place: "Erinnerungspolitik als Vita Activa gegen Antisemitismus",
    url: "https://www.erinnern.at/bundeslaender/wien/termine/podiumsdiksussion-erinnerungspolitik-als-vita-activa-gegen-antisemitismus",
  },
  {
    id: "minds-2024",
    date: "2024-04-25",
    period: "25–26 Apr 2024",
    format: "Presentation",
    title: "MINDS Conference at Reuters, London",
    place: "newsrooms.ai for international news agencies",
    url: "https://newsrooms.ai/blog/",
  },
  {
    id: "culttech-2024",
    date: "2024-11-05",
    period: "5–6 Nov 2024",
    format: "Keynote",
    title: "CultTech Summit 2024, Vienna",
    place: "newsrooms.ai",
    url: "https://transform.show/speakers/matteo-rosoli",
  },
  {
    id: "pcon-2025",
    date: "2025-10-02",
    period: "2 Oct 2025",
    format: "Keynote",
    title: "PCon 2025, Vienna",
    place:
      "KI-Qualitätsoffensive: Wie wir mit intelligenten Tools den Content-Slop besiegen",
    url: "https://newsrooms.ai/blog/",
  },
  {
    id: "culttech-2025",
    date: "2025-10-22",
    period: "22 Oct 2025",
    format: "Roundtable",
    title: "CultTech Summit 2025, Vienna",
    place:
      "Scalable, on-brand and legally compliant content without content slop",
    url: "https://newsrooms.ai/blog/en/culttech-summit-2025-roundtable/",
  },
  {
    id: "nts-2025",
    date: "2025-11-04",
    period: "4 Nov 2025",
    format: "Talk",
    title: "New Technologies Summit 2025, Vienna",
    place:
      "KI-Qualitätsoffensive: Warum Prompten Problem #1 in der effizienten KI-Nutzung ist",
    url: "https://www.b2match.com/e/new-technologies-summit-2025/participants/3241931",
  },
  {
    id: "adv-2025",
    date: "2025-11-19",
    period: "2025",
    format: "Talk",
    title: "ADV Austrian Digital Value",
    place: "AI Quality Offensive: Why Prompting Is Problem #1",
    url: "https://newsrooms.ai/blog/en/adv-ai-quality-offensive-prompting/",
  },
  {
    id: "mcoe-2026",
    date: "2026-01-28",
    period: "28 Jan 2026",
    format: "Talk & live demo",
    title: "MCÖ Digital Marketing Experts Talk, Vienna",
    place: "Marken-Authentizität statt KI-Einheitsbrei, with Timo Wagner",
    url: "https://marketingclub.at/event/marken-authentizit%C3%A4t-statt-ki-einheitsbrei-warum-europ%C3%A4ische-ki-den-unterschied-macht",
  },
  {
    id: "boersepeople-2026",
    date: "2026-02-09",
    period: "9 Feb 2026",
    format: "Podcast",
    title: "Börsepeople im Podcast",
    place: "S23/12 with Christian Drastil",
    url: "https://www.audio-cd.at/page/podcast/8378/b%C3%B6rsepeople_im_podcast_s23-12%3A_matteo_rosoli",
  },
  {
    id: "tt-openclaw-2026",
    date: "2026-02-13",
    period: "13 Feb 2026",
    format: "Podcast",
    title: "Trending Topics Tech Talk",
    place: "OpenClaw darf nicht ClosedClaw werden",
    url: "https://newsrooms.ai/blog/de/openclaw-darf-nicht-closedclaw-werden/",
  },
  {
    id: "tt-ai-factory-2026",
    date: "2026-02-27",
    period: "27 Feb 2026",
    format: "Podcast",
    title: "Trending Topics Tech Talk",
    place: "AI Factory Austria: Vision der digitalen Souveränität Europas",
    url: "https://open.spotify.com/episode/5MrSOGRfirnvJxf8KSghh6",
  },
  {
    id: "transform-2026",
    date: "2026-03-19",
    period: "19 Mar 2026",
    format: "Keynote",
    title: "TRANSFORM 2026, Berlin",
    place: "KI Qualitätsoffensive: Content-Qualität ohne Slop und ohne Prompts",
    url: "https://transform.show/speakers/matteo-rosoli",
  },
  {
    id: "tt-marktluecke-2026",
    date: "2026-03-26",
    period: "26 Mar 2026",
    format: "Podcast",
    title: "Trending Topics Tech Talk",
    place:
      "In Europa gibt es eine riesige Marktlücke für einen souveränen KI-Agenten",
    url: "https://podcasts.apple.com/at/podcast/in-europa-gibt-es-eine-riesige-marktl%C3%BCcke-f%C3%BCr-einen/id1533084242?i=1000755892006",
  },
  {
    id: "tt-eustella-2026",
    date: "2026-04-14",
    period: "14 Apr 2026",
    format: "Podcast",
    title: "Trending Topics Tech Talk",
    place: "So bauen wir eustella zu einem europäischen ChatGPT-Rivalen auf",
    url: "https://podcasts.apple.com/at/podcast/so-bauen-wir-eustella-zu-einem-europ%C3%A4ischen-chatgpt/id1533084242?i=1000761227126",
  },
  {
    id: "ecommerce-inspiration-2026",
    date: "2026-04-14",
    period: "14 Apr 2026",
    format: "Podcast",
    title: "E-Commerce Inspiration #062",
    place: "AI made in Austria: der KI-Status-quo, with Thomas Leskowsky",
    url: "https://podcasts.apple.com/at/podcast/062-ai-made-in-austria-matteo-rosoli-von-newsroom-ai/id1700502071?i=1000761403794",
  },
  {
    id: "breaking-media-2026",
    date: "2026-04-21",
    period: "21 Apr 2026",
    format: "TV",
    title: "Breaking Media, PULS 4 & JOYN",
    place: "AI agents and eustella",
    url: "https://www.ots.at/presseaussendung/OTS_20260421_OTS0085/ki-zukunft-causa-weissmann-pro-und-contra-am-dienstag-um-2220-uhr-auf-joyn-puls-4",
  },
  {
    id: "ai-austria-2026",
    date: "2026-05-28",
    period: "28 May 2026",
    format: "Presentation",
    title: "AI Austria GenAI Community, Vienna",
    place: "A first look at eustella, with Jakob Steinschaden",
    url: "https://www.meetup.com/ai-austria/events/314613684/",
  },
  {
    id: "eustella-launch-2026",
    date: "2026-06-24",
    period: "24 Jun 2026",
    format: "Launch",
    title: "eustella launch at AI Factory Austria, Vienna",
    place: "Press conference, live demo and panel",
    url: "https://presse.ait.ac.at/news-press-event-eustella-presents-a-sophisticated-ai-agent-for-europe?id=243791&l=english&menueid=34057",
  },
  {
    id: "future-weekly-2026",
    date: "2026-07-05",
    period: "5 Jul 2026",
    format: "Podcast",
    title: "Future Weekly #530",
    place:
      "Ehrliche Souveränität, Kaderschmieden & der wahre Kern der Sprache, with Markus Raunig",
    url: "https://podcasts.apple.com/at/podcast/530-matteo-rosoli-%C3%BCber-ehrliche-souver%C3%A4nit%C3%A4t-kaderschmieden/id1491263926?i=1000775490718",
  },
  {
    id: "ki-europe-days-2026",
    date: "2026-07-15",
    period: "15 Jul 2026",
    format: "Online talk",
    title: "KI made in Europe – DAYs",
    place:
      "Souveräne KI-Sprache aus Europa: Wie Unternehmen mit newsrooms ihre eigene Stimme behalten",
    url: "https://www.marketing-on-tour.de/konferenzen-seminare/ki-europe-days/",
  },
];

// Each appearance belongs to the milestone it happened after (ends of things don't collect any)
export const talksByEntry = (() => {
  const heads = entries
    .filter((e) => !e.id.endsWith("-end"))
    .sort((a, b) => b.date.localeCompare(a.date));
  const groups = {};
  [...appearances]
    .sort((a, b) => b.date.localeCompare(a.date))
    .forEach((a) => {
      const head = heads.find((e) => e.date <= a.date);
      if (!head) return;
      (groups[head.id] = groups[head.id] || []).push(a);
    });
  return groups;
})();
